<template>
  <div>
    <!-- Add -->
    <a-modal v-model="visible" title="Add Student Fee" onOk="handleOk">
      <template slot="footer">
          <a-button key="back" @click="handleCancel">Cancel</a-button>
          <a-button key="submit" type="primary" :loading="loading" @click="handleAdd">Add Student Fee</a-button>
      </template>
      <a-spin :spinning="spinning">
        <div class="row" v-if="studentFeeData">
<!--          <div class="col-md-6">
            <p>Fee: <span class="font-weight-bold">{{studentFeeData.fee_setting.class_fee.fee.name}}</span></p>
          </div>
          <div class="col-md-6">
            <p>Fee Total: <span class="font-weight-bold">₹ {{feeTotal}}</span></p>
          </div>
          <div class="col-md-6">
            <p>Start Date: <span class="font-weight-bold">{{moment(studentFeeData.start_date).format('DD-MM-YYYY')}}</span></p>
          </div>
          <div class="col-md-6">
            <p>Last Date: <span class="font-weight-bold">{{moment(studentFeeData.end_date).format('DD-MM-YYYY')}}</span></p>
          </div>-->
        </div>

        <hr class="my-2">

        <a-form class="mb-0" :form="form" @submit="handleAdd">
          <div class="row mb-0">
            <div class="col-md-12 mb-2">
              <a-form-item
                label="Select Class Fee"
              >
                <a-spin :spinning="feesLoading">
                  <a-select
                    v-decorator="[
                    'fee_id',
                    {rules: [{ required: true, message: 'Please select a class fee!!' }]}
                  ]"
                    placeholder="Fee"
                    @change="handleFeeChange"
                  >
                    <a-select-option v-for="feeSetting in generatedFees" :value="feeSetting.class_fee ? feeSetting.class_fee.fee.id : feeSetting.fee_id" :key="feeSetting.class_fee ? feeSetting.class_fee.fee.id : feeSetting.fee_id">
                      {{feeSetting.class_fee ? feeSetting.class_fee.fee.name : feeSetting.fee.name}}
                    </a-select-option>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>
            <div class="col-md-6 mb-2">
              <a-form-item class="mb-0" label="Amount">
                <div style="width:120px;">
                  <a-input-number
                    placeholder="Amount"
                    v-decorator="[`fee_amount`, {rules: [{ required: false, message: 'Please input fee amount!' }]}]"
                    :initialValue="0"
                    :min="0"
                    :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                    style="width:100%;"
                    @change="handleFieldValueChange"
                    :disabled="false"
                  />
                </div>
              </a-form-item>
            </div>
            <div class="col-md-6 mb-2">
              <a-tooltip
                placement="top"
                title="⚠️ If auto fine is enabled then subtract auto fine amount before update"
              >
              <a-form-item class="mb-0" label="Fine Amount ⚠️">
                <div style="width:120px;">
                  <a-input-number
                    placeholder="Fine"
                    v-decorator="[`fine_amount`, {rules: [{ required: false, message: 'Please input fine amount!' }]}]"
                    :initialValue="0"
                    :min="0"
                    :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                    style="width:100%;"
                    @change="handleFieldValueChange"
                    :disabled="true"
                  />
                </div>
              </a-form-item>
              </a-tooltip>
            </div>
          </div>
          <div class="row mb-0">
<!--            <div class="col-md-6 mb-2">
              <a-form-item label="Discount Type">
                <a-select style="width:150px" v-model="discountType">
                  <a-select-option value="amount">Amount</a-select-option>
                  <a-select-option value="percentage">Percentage</a-select-option>
                </a-select>
              </a-form-item>
            </div>-->
<!--            <div class="col-md-6 mb-2" v-if="discountType === 'amount'">-->
            <div class="col-md-6 mb-2">
              <a-form-item class="mb-0" label="Discount Amount">
                <div style="width:120px;">
                  <a-input-number
                    placeholder="Discount amount"
                    v-decorator="[`discount_amount`, {rules: [{ required: false, message: 'Please input fee amount!' }]}]"
                    :initialValue="0"
                    :min="0"
                    :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                    style="width:100%;"
                    @change="handleFieldValueChange"
                    :disabled="true"
                  />
                </div>
<!--                </div>-->
              </a-form-item>
            </div>
<!--            <div class="col-md-6 mb-2" v-if="discountType === 'percentage'">-->
            <div class="col-md-6 mb-2">
              <a-form-item class="mb-0" label="Discount % (of Amount)">
                <div style="width:120px;">
                  <a-input-number
                    placeholder="Discount %"
                    v-decorator="[`discount_percentage`, {rules: [{ required: false, message: 'Please input fee amount!' }]}]"
                    :initialValue="0"
                    :min="0"
                    :max="100"
                    :formatter="value => `${value}%`"
                    :parser="value => value.replace(/\%\s?|(,*)/g, '')"
                    style="width:100%;"
                    @change="handleFieldValueChange"
                    :disabled="true"
                  />
                </div>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'AddStudentFee',
  props: ['classId', 'sessionId'],
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      dateFormat: 'DD-MM-YYYY',
      classFees: null,
      feesLoading: false,
      studentFeeId: null,
      studentFeeData: null,
      discountType: 'amount',
      feeTotal: null,
      enrollmentId: null,
      generatedFees: null,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openAddStudentFeesModal', this.showModal)
  },
  created: function() {

  },
  methods: {
    moment,
    showModal: function(enrollment) {
      console.log(enrollment)
      this.enrollmentId = enrollment.id
      this.visible = true
      this.spinning = true
      this.loading = true
      this.getGeneratedFees(enrollment)
    },
    getGeneratedFees(enrollment) {
      this.$http.get('/api/fee_setting', {
        params: {
          session_id: enrollment.session_id,
          class_id: enrollment.class_id,
        },
      })
        .then(({ data }) => {
          this.generatedFees = data.data
          this.loading = false
          this.spinning = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    handleFieldValueChange: function (value) {
      this.$nextTick(function() {
        const amount = this.form.getFieldValue('amount')
        const fine = this.form.getFieldValue('fine')
        const discountAmount = this.form.getFieldValue('discount_amount')
        const discountPercent = this.form.getFieldValue('discount_percentage')
        this.feeTotal = amount - (amount * (discountPercent / 100)) - discountAmount + fine
      })
    },
    handleAdd: function (e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              const formData = this.makeEditFormData(values)
              this.$http
                .post('/api/student_fee', formData)
                .then(({ data }) => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully updated',
                    description: `Student fees updated successfully!`,
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
              this.form.reset()
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    makeFeeData: function(studentFee) {
      const fieldData = {
        amount: studentFee.amount,
        fine: studentFee.fine,
        discount_amount: studentFee.discount_amount,
        discount_percentage: studentFee.discount_percentage,
      }
      /* if (studentFee.discount_percentage) {
        fieldData.discount_percentage = studentFee.discount_percentage
      } else {
        fieldData.discount_amount = studentFee.discount_amount
      } */
      return fieldData
    },
    makeEditFormData(values) {
      let data = {
        enrollment_id: this.enrollmentId,
        fee_ids: [values.fee_id],
        /* amount: values.amount,
        fine: values.fine,
        discount_amount: values.discount_amount,
        discount_percentage: values.discount_percentage, */
      }

      /* if (this.discountType === 'amount') {
        data.discount_amount = values.discount_amount
        data.discount_percentage = 0
      }
      if (this.discountType === 'percentage') {
        data.discount_amount = 0
        data.discount_percentage = values.discount_percentage
      } */
      return data
    },
    handleFeeChange(feeId) {
      const fee = this.generatedFees.find(feeSetting => feeSetting.class_fee ? (feeSetting.class_fee.fee_id === feeId) : (feeSetting.fee_id === feeId))
      if (fee) {
        this.form.setFieldsValue({
          fee_amount: fee.fee_amount,
          fine_amount: fee.fine_amount,
          discount_amount: fee.discount_amount,
          discount_percentage: fee.discount_percentage,
        })
      } else {
        this.form.setFieldsValue({ fee_amount: 0 })
      }
    },
  },
}
</script>
